import { Injectable } from '@angular/core'; 
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { share } from 'rxjs/operators';
import { User } from '../models/user';
import { environment } from 'src/environments/environment';
import { Filter } from '../models/filter';
import { ParameterConst } from '../util/constant';
import { Md5 } from 'ts-md5';

@Injectable({
  providedIn: 'root'
})
export class UserService { 
  
  private url_list_users = environment.apiEndpoint + "api/obtenerUsuarios.php";
  private url_add_user = environment.apiEndpoint + "api/registrarUsuario.php";
  private url_request_password = environment.apiEndpoint + "ajax/updateContrasenaUsuario.php";

  constructor(private _http:HttpClient){}
  
  obtenerUsuarios(filter : Filter): Observable<any>{

    const formData = new FormData();
    formData.append("nombre", filter.nombre);

    return this._http.post(this.url_list_users,formData).pipe(share());

  }

  changePassword(access: string, hash: string): Observable<any>{

    const formData = new FormData();
    formData.append("access", access);
    formData.append("hash", hash);
    return this._http.post(this.url_request_password,formData).pipe(share());
   
  }



}
 
